import { render, staticRenderFns } from "./BprIcon.vue?vue&type=template&id=0e06e672&scoped=true&"
import script from "./BprIcon.vue?vue&type=script&lang=js&"
export * from "./BprIcon.vue?vue&type=script&lang=js&"
import style0 from "./BprIcon.vue?vue&type=style&index=0&id=0e06e672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e06e672",
  null
  
)

export default component.exports